module.exports = __webpack_public_path__ + "static/img/jrliu.2d5adb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jrliu.jpg
// module id = Olea
// module chunks = 0